<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->
   <!--  
    Build EditIbansRequest(EditIbans.vue)
    Send EditIbansRequest to Shaparak
    Inquiery sent request from Shaparak
    -->
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    :title="`مدیریت حسابها &quot;` + shopName + `&quot;`"
    :active.sync="popupActive"
  >
    <div v-show="viewEditIban">
      <edit-ibans ref="EditIbans1" @success="edited" @cancel="cancelEdit" />
    </div>
    <div v-show="!viewEditIban">
      <div v-if="step == Step.Complate" class="vx-row mb-2 w-full">
        <div class="vx-col w-full flex" style="justify-content: center">
          برای پیگیری درخواست می توانید به صفحه درخواستها بروید.
          <br />
          جهت ارسال درخواست به شاپرک می توانید از دکمه زیر استفاده کنید
        </div>
        <div class="vx-col w-full flex" style="justify-content: center">
          <vs-button
            @click="edit"
            class="my-3 mx-2"
            color="success"
            type="border"
            icon-pack="feather"
            icon="icon-edit"
            >ویرایش</vs-button
          >
          <vs-button
            @click="sendRequest"
            class="my-3"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-send"
            >ارسال درخواست به شاپرک</vs-button
          >
        </div>
      </div>
      <div v-else-if="step == Step.Inquiery" class="vx-row mb-2 w-full">
        <div class="vx-col w-full flex" style="justify-content: center">
          برای پیگیری درخواست می توانید به صفحه درخواستها بروید.
          <br />
          جهت استعلام از شاپرک می توانید از دکمه زیر استفاده کنید
        </div>
        <div class="vx-col w-full flex" style="justify-content: center">
          <vs-button
            @click="inquiry"
            class="my-3"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-send"
            >استعلام از شاپرک</vs-button
          >
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<style>
</style>
<script>
import EditIbans from "./EditIbans.vue";
const Step = Object.freeze({
  Create: 1,
  Complate: 2,
  Inquiery: 3,
});
export default {
  name: "management-ibans",
  props: {},
  components: {
    EditIbans,
  },
  data() {
    return {
      popupActive: false,
      items: [],
      shopName: "",
      merchantId: null,
      draftRequest: null,
      step: null,
      Step,
      viewEditIban: false,
    };
  },
  methods: {
    show(merchantId, shopName = "") {
      if (merchantId) {
        this.merchantId = merchantId;
        this.shopName = shopName;
        this.viewEditIban = false;
        this.getDraft();
      }
    },

    getDraft() {
      let payload = {
        params: {
          id: this.merchantId,
        },
      };
      let loading = this.$vs.loading();
      this.$http
        .get(`/api/services/app/draft/GetLastDraft`, payload)
        .then((response) => {
          this.draftRequest = response.data.result;
          if (this.draftRequest && this.draftRequest.parentId) {
            //exist draft
            if (this.draftRequest.step == 6) {
              //Is editIban
              if ([3].includes(this.draftRequest.state)) {
                //IsComplate
                this.step = this.Step.Complate;
              } else if ([8].includes(this.draftRequest.state)) {
                //Is waiting
                this.step = this.Step.Inquiery;
              } else {
                this.step = this.Step.Create;
                this.showEditIban();
              }
            } else {
              //Is not editIban
              if (![14].includes(this.draftRequest.state)) {
                //Is not approved
                this.$vs.notify({
                  time: 5000,
                  color: "success",
                  title: "خطا!",
                  text: `درخواست دیگری در حال پیگیری است.`,
                });
                this.$vs.loading.close();
                return;
              } else {
                this.step = this.Step.Create;
                this.showEditIban();
              }
            }
          } else {
            this.step = this.Step.Create;
            this.showEditIban();
          }
          this.popupActive = true;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    edit() {
      // this.$vs.notify({
      //   time: 5000,
      //   color: "success",
      //   title: "خطا!",
      //   text: `در حال حاضر امکان ویرایش وجود ندارد.`,
      // });
      // return;
      this.showEditIban();
    },
    showEditIban() {
      this.viewEditIban = true;
      this.$refs.EditIbans1.show(this.merchantId, this.shopName);
    },
    edited() {
      this.viewEditIban = false;
        this.getDraft();
    },
    cancelEdit() {
      if (this.Step.Create == this.step) {
        this.popupActive = false;
      } else {
        this.viewEditIban = false;
      }
    },
    sendRequest() {
      let loading = this.$vs.loading();
      this.$http
        .post("/api/services/app/DraftShaparak/EditIbanRequest?id="+this.merchantId)
        .then((response) => {
          if (response.data.result == true) {
            this.step = "SendRequest";
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `درخواست با موفقیت به شاپرک ارسال شد.`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    inquiry() {
      let payload = {
        id: this.merchantId,
      };
      let loading = this.$vs.loading();
      this.$http
        .post("/api/services/app/DraftShaparak/ProcessInquiry", payload)
        .then((response) => {
          if (response.data.result == true) {
            this.step = "SendRequest";
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `درخواست با موفقیت به شاپرک ارسال شد.`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
};
</script>
